const _ = require('lodash');
const React = require('react');
import ReactDOM from 'react-dom';

// var Selection = React.createClass({
class Selection extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            mouseDown: false,
            startPoint: null,
            endPoint: null,
            selectionBox: null,
            appendMode: true
        };

        
        this.selectedChildren = props.selectedChildren ? props.selectedChildren : {};
        //console.log('CONSTRUCTING', this.selectedChildren)
        this.selectionBox = React.createRef();

        this._onMouseDown = this._onMouseDown.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);
        this._onMouseUp = this._onMouseUp.bind(this);
        this.renderChildren = this.renderChildren.bind(this);
        this.renderSelectionBox = this.renderSelectionBox.bind(this);
        this._calculateSelectionBox = this._calculateSelectionBox.bind(this);
        this._updateCollidingChildren = this._updateCollidingChildren.bind(this);
    }

    /**
     * On componentn mount
     */
    componentWillMount() {
        //     this.selectedChildren = {};
    }

    /**
     * On component props change
     */
    componentWillReceiveProps(nextProps) {
        //console.log('componentWillReceiveProps', nextProps);
        this.selectedChildren = nextProps.selectedChildren ? nextProps.selectedChildren : {};
    }

    /**
     * On component update
     */
    componentDidUpdate() {
        if (this.state.mouseDown && !_.isNull(this.state.selectionBox)) {
            this._updateCollidingChildren(this.state.selectionBox);
        }
    }

    /**
     * On root element mouse down
     */
    _onMouseDown(e) {
        if (!this.props.enabled || e.button === 2 || e.nativeEvent.which === 2) {
            return;
        }
        const nextState = {};
        if (e.ctrlKey || e.altKey || e.shiftKey) {
            nextState.appendMode = true;
        } else {
            // @todo improve this logic to be able to remove items with select box
            // if there are items, keep appending new items when selecting
            if (_.keys(this.selectedChildren).length) {
                nextState.appendMode = true;
            } else {
                nextState.appendMode = false;
            }
        }
        nextState.mouseDown = true;
        nextState.startPoint = {
            x: e.pageX,
            y: e.pageY
        };
        //console.log(nextState)
        this.setState(nextState);
        window.document.addEventListener('mousemove', this._onMouseMove);
        window.document.addEventListener('mouseup', this._onMouseUp);
    }

    /**
     * On document element mouse up
     */
    _onMouseUp(e) {
        window.document.removeEventListener('mousemove', this._onMouseMove);
        window.document.removeEventListener('mouseup', this._onMouseUp);
        this.setState({
            mouseDown: false,
            startPoint: null,
            endPoint: null,
            selectionBox: null,
            appendMode: true
        });
        this.props.onSelectionChange.call(null, this.selectedChildren);
    }

    /**
     * On document element mouse move
     */
    _onMouseMove(e) {
        e.preventDefault();
        if (this.state.mouseDown) {
            const endPoint = {
                x: e.pageX,
                y: e.pageY
            };
            this.setState({
                endPoint,
                selectionBox: this._calculateSelectionBox(this.state.startPoint, endPoint)
            });
        }
    }

    /**
     * Render
     */
    render() {
        const className = `selection ${this.state.mouseDown ? 'dragging' : ''}`;
        return (
            <div className={className} ref={this.selectionBox} onMouseDown={this._onMouseDown}>
                {this.renderChildren()}
                {this.renderSelectionBox()}
            </div>
        );
    }

    /**
     * Render children
     */
    renderChildren() {
        let index = 0;
        const _this = this;
        let tmpChild;
        //console.log('this.selectedChildren', this.selectedChildren);
        return React.Children.map(this.props.children, function(child) {
            const tmpKey = _.isNull(child.key) ? index++ : child.key;
            const isSelected = _.has(_this.selectedChildren, tmpKey);
            tmpChild = React.cloneElement(child, {
                ref: tmpKey,
                selectionParent: _this,
                isSelected
            });
            return React.createElement('div',
                {
                    className: `select-box ${isSelected ? 'selected' : ''}`,
                    onClickCapture(e) {
                        if (/*(e.ctrlKey || e.altKey || e.shiftKey) &&*/ _this.props.enabled) {
                            e.preventDefault();
                            e.stopPropagation();
                            _this.selectItem(tmpKey, !_.has(_this.selectedChildren, tmpKey));
                        }
                    }
                },
                tmpChild
            );
        });
    }

    /**
     * Render selection box
     */
    renderSelectionBox() {
        if (!this.state.mouseDown || _.isNull(this.state.endPoint) || _.isNull(this.state.startPoint)) {
            return null;
        }
        return <div className="selection-border" style={this.state.selectionBox}></div>;
    }

    /**
     * Manually update the selection status of an item
     * @param {string} key the item's target key value
     * @param {boolean} isSelected the item's target selection status
     */
    selectItem(key, isSelected) {
        if (isSelected) {
            this.selectedChildren[key] = isSelected;
        } else {
            delete this.selectedChildren[key];
        }
        this.props.onSelectionChange.call(null, this.selectedChildren);
        this.forceUpdate();
    }

    /**
     * Select all items
     */
    selectAll() {
        _.each(
            this.refs,
            function(ref, key) {
                if (key !== 'selectionBox') {
                    this.selectedChildren[key] = true;
                }
            }.bind(this)
        );
    }

    /**
     * Manually clear selected items
     */
    clearSelection() {
        this.selectedChildren = {};
        this.props.onSelectionChange.call(null, []);
        this.forceUpdate();
    }

    /**
     * Detect 2D box intersection
     */
    _boxIntersects(boxA, boxB) {
        if (
            boxA.left <= boxB.left + boxB.width &&
            boxA.left + boxA.width >= boxB.left &&
            boxA.top <= boxB.top + boxB.height &&
            boxA.top + boxA.height >= boxB.top
        ) {
            return true;
        }
        return false;
    }

    getCoords(elem) { // crossbrowser version
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top  = box.top +  scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }

    /**
     * Updates the selected items based on the
     * collisions with selectionBox
     */
    _updateCollidingChildren(selectionBox) {
        let tmpNode = null;
        let tmpBox = null;
        let tmpNodeCoords = null;
        const _this = this;
        const parentNode = this.selectionBox.current;
        //console.log(parentNode)
        _.each(this.refs, function(ref, key) {
            if (key !== 'selectionBox') {
                tmpNode = ReactDOM.findDOMNode(ref);
                //console.log('tmpNode.offsetParent', tmpNode, );
                tmpNodeCoords = _this.getCoords(tmpNode);
                //tmpNode.parent.style.background = 'red'
                tmpBox = {
                    top: tmpNodeCoords.top,
                    left: tmpNodeCoords.left,
                    width: tmpNode.clientWidth,
                    height: tmpNode.clientHeight
                };
                //console.log(selectionBox, tmpBox, parentNode.offsetLeft)
                if (_this._boxIntersects(selectionBox, tmpBox)) {
                    _this.selectedChildren[key] = true;
                } else if (!_this.state.appendMode) {
                    delete _this.selectedChildren[key];
                }
            }
        });
    }

    /**
     * Calculate selection box dimensions
     */
    _calculateSelectionBox(startPoint, endPoint) {
        if (!this.state.mouseDown || _.isNull(endPoint) || _.isNull(startPoint)) {
            return null;
        }
        //console.log(this.selectionBox);
        const parentNode = this.selectionBox.current;
        const left = Math.min(startPoint.x, endPoint.x) - parentNode.offsetLeft;
        const top = Math.min(startPoint.y, endPoint.y) - parentNode.offsetTop;
        const width = Math.abs(startPoint.x - endPoint.x);
        const height = Math.abs(startPoint.y - endPoint.y);
        //console.log(left, top)
        return {
            left,
            top,
            width,
            height
        };
    }
}

export default Selection;
